<template>
  <div>

    <!-- [ Modal form Template ] start -->
    <sweet-modal blocking ref="template" class="modal" v-on:close="closeModal">
      <h1 class="modal__title">Project Template</h1>

      <div class="tree">
        <div class="template">
          <div class="template__item" v-for="template in templatesProject" :key="template.id">
            <div class="template__item_name">{{template.name}}</div>
            <div class="template__item_link">
              <el-button disabled type="warning" icon="el-icon-share" size="mini" plain></el-button>
              <el-button @click="editTemplateProject(template.id)" type="primary" icon="el-icon-edit" size="mini" plain></el-button>
              <el-button @click="deleteTemplateProject(template.id)" type="danger" icon="el-icon-delete" size="mini" plain></el-button>
            </div>
          </div>
        </div>
      </div>

    </sweet-modal>
    <!-- [ Modal form Template ] end -->

    <sweet-modal blocking ref="nestedChild" class="modal">
      <h1 class="modal__title">Edit Project Template</h1>

      <el-form :model="form" status-icon :rules="rules" ref="form" label-width="100px" class="demo-ruleForm">
        <el-form-item prop="name" label="Name">
          <el-input v-model="form.name" size="mini" placeholder="Name"></el-input>
        </el-form-item>
        <el-form-item prop="description" label="Description">
          <el-input v-model="form.description" size="mini" placeholder="Description"></el-input>
        </el-form-item>

        <el-form-item class="modal__btn">
          <el-button @click="submitForm('form')" type="primary" plain size="mini">Edit</el-button>
        </el-form-item>
      </el-form>

    </sweet-modal>

    <!-- [ Modal are you sure ] start -->
    <sweet-modal blocking ref="confirmation" title="Delete template" class="modal">
        Are you sure you want to delete this project template?
        <template slot="box-action">
            <a class="button" @click="deleteConfirm">Ok</a> &nbsp;
            <a class="button" @click="$refs.confirmation.close()">Cancel</a>
        </template>
    </sweet-modal>
    <!-- [ Modal are you sure ] end -->

  </div>
</template>

<script>
import { SweetModal } from '@totalflow4/tfsweet-modal-vue'
import axios from 'axios'
export default {
  components: {
    SweetModal,

  },
  props: ['template'],
  computed: {
    templatesProject() {
      return this.$store.getters.getTemplatesProject
    },
  },
  data() {
    return {

      templateId: null,
      itemTemplateProject: null,
      projectTemplateId: null,
      form: {
        name: '',
        description: '',
      },
      rules: {
        name: [{
          required: true,
          message: 'Name Template is required',
          trigger: 'blur'
        }],
        description: [{
          required: true,
          message: 'Name Template is required',
          trigger: 'blur'
        }],
      }
    }
  },
  methods: {
    closeModal() {
      this.$refs['form'].resetFields();
      this.form.name = null
      this.form.description = null
    },
    notification(title, message, type) {
      this.$notify({
        title: title,
        message: message,
        type: type
      });
    },
    submitForm(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          console.log('submit');
          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .post(`/api/v1/projectTemplates/update?companyId=${this.$route.query.companyId}&projectTemplateId=${this.templateId}`, {
              name: this.form.name,
              description: this.form.description,
            })
            .then(response => {
              console.log('---', response.data);
              this.$store.dispatch('getTemplatesProject')
              this.$refs.nestedChild.close();
              this.notification("Success", "Update Template", "success");
              loader.hide()
            })
            .catch(error => {
              console.log('An error occurred:', error);
              loader.hide()
            });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    deleteConfirm() {
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
          .post(`/api/v1/projectTemplates/delete?companyId=${this.$route.query.companyId}&projectTemplateId=${this.projectTemplateId}`)
          .then(response => {
            console.log('---/projectTemplates/delete', response.data);
            this.notification("Success", "Delete Template", "success");
            this.$store.dispatch('getTemplatesProject')
            this.$refs.confirmation.close();
            loader.hide()
          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          });
    },
    deleteTemplateProject(id) {
      this.projectTemplateId = id
      // this.$refs.confirmation.open();

      this.$confirm('This will permanently delete the templates. Continue?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'info'
      }).then(() => {
        this.$message({
          type: 'success',
          message: 'Delete completed'
        });

        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
            .post(`/api/v1/projectTemplates/delete?companyId=${this.$route.query.companyId}&projectTemplateId=${this.projectTemplateId}`)
            .then(response => {
              console.log('---/projectTemplates/delete', response.data);
              this.notification("Success", "Delete Template", "success");
              this.$store.dispatch('getTemplatesProject')
              this.$refs.confirmation.close();
              loader.hide()
            })
            .catch(error => {
              console.log('An error occurred:', error);
              loader.hide()
            });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Delete canceled'
        });
      });
    },
    editTemplateProject(id) {
      let projectTemplateId = id
      this.templateId = id
      this.$refs.nestedChild.open()

      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
          .post(`/api/v1/projectTemplates/item?companyId=${this.$route.query.companyId}&projectTemplateId=${projectTemplateId}`)
          .then(response => {
            console.log('---/projectTemplates/item', response.data.item);
            // this.itemTemplateProject = response.data.item
            this.form.name = response.data.item.name
            this.form.description = response.data.item.description
            loader.hide()
          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          });
    },
  },
}
</script>

<style lang="scss" scoped>
.tree {
  width: 100%;
  height: 450px;
  overflow-y: auto;
  font-size: 16px;
  overflow: auto;
  .template {
    border-bottom: 1px dashed #d9d9d9;
    &:last-child {
      border-bottom: none;
    }
    &__item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 40px;
      border-bottom: 1px dashed #d9d9d9;

      &_link {
        display: flex;
      }

      &_name {
        // cursor: pointer;
      }
    }
  }
}

.modal {
  color: #000;
  &__title {
    text-align: center;
  }
  &__btn {
    text-align: right;
  }
}

// [ Modal ] start
.button{
  cursor: pointer;
}
// [ Modal ] end
</style>
